import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskSurveysRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/surveys/:surveyId?/(edit|settings)?',
	name: 'servicedesk-surveys',
};
